import { store } from "../../store";

export const get = () => store.getState().services.session;

export const isLoggedIn = () => get().token !== null;

export const getUser = () => get().user;
